class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (!this.currentVariant) {
      this.toggleAddButton(true, window.variantStrings.unavailable, true);
      this.setUnavailable();
      return;
    }

    this.updateMedia();
    this.updateVariantInput();
    this.updateURL();
    this.renderProductInfo();
    this.renderFindLoaction();

    if (this.currentVariant.available) {
      this.toggleAddButton(false, window.variantStrings.addToCart, true);
    } else {
      this.toggleAddButton(true, window.variantStrings.soldOut, true);
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if (document.querySelector('.media-thumb')) {
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if (mediaid == fetured_id) {
          new Swiper('.media-nav').slideTo(e.dataset.index, 1000, false);
        }
      });
    }
    if (document.querySelector('.media-grid-column').classList.toString().includes('swiper-slide')) {
      var media_id = this.currentVariant?.featured_media?.id;
      if (media_id) {
        if (document.querySelector('.media-grid-column[data-media-id="'+ media_id +'"]')) {
          var image_index = parseInt(document.querySelector('.media-grid-column[data-media-id="'+ media_id +'"]').getAttribute('data-swiper-slide-index'));
          if (swiper && swiper.slideTo) {
            swiper.slideTo(image_index, 1000, false);
          }
        }
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if (checked_gender) {
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if (option_count >= fieldlen) {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if (option_count >= fieldlen) {
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
    } else {
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;

        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }
      });
  }

  renderFindLoaction() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `find-loaction-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;

        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const bisTrigger = productForm.querySelector(`.product-bis-trigger-${this.dataset.section}`);
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const addButtonText2 = bisTrigger?.querySelector('span');
    if (!addButton || !bisTrigger) return;

    // 🟢 Removed timeout — no more “Sold out” flicker
    if (disable) {
      bisTrigger.classList.remove('d-none');
      addButton.classList.add('d-none');
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (text) addButtonText2.textContent = 'Sold out – Register your interest';
      if (document.querySelectorAll('.snippet-addto-cart.wc_comming_soon').length) {
        if (text) addButtonText2.textContent = 'Coming soon – Register your interest';
      }
    } else {
      bisTrigger.classList.add('d-none');
      addButton.classList.remove('d-none');
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      addButtonText2.textContent = 'Add to bag';
    }

    if (!modifyClass) return;
  }


  // toggleAddButton(disable = true, text = null, modifyClass = true) {
  //   const productForm = document.getElementById(`product-form-${this.dataset.section}`);
  //   if (!productForm) return;

  //   const addButton = productForm.querySelector('[name="add"]');
  //   const bisTrigger = productForm.querySelector(`.product-bis-trigger-${this.dataset.section}`);
  //   const addButtonText = productForm.querySelector('[name="add"] > span');

  //   if (!addButton) return;

  //   if (disable) {
  //     if (text) {
  //       addButtonText.textContent = text;
  //     }
  //     if (text === window.variantStrings.addToCart) {
  //       bisTrigger?.classList.remove('d-none');
  //       addButton.classList.add('d-none');
  //     } else {
  //       addButton.classList.remove('d-none');
  //       bisTrigger?.classList.add('d-none');
  //     }
  //     addButton.setAttribute('disabled', 'disabled');
  //   } else {
  //     bisTrigger?.classList.add('d-none');
  //     addButton.classList.remove('d-none');
  //     addButton.removeAttribute('disabled');
  //     addButtonText.textContent = window.variantStrings.addToCart || text;
  //   }

  //   if (!modifyClass) return;
  // }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-radios', VariantRadios);

// class VariantRadios extends HTMLElement {
//   constructor() {
//     super();
//     this.addEventListener('change', this.onVariantChange);    
//   }
//   onVariantChange() {
//     this.updateOptions();
//     this.updateMasterId();
//     this.toggleAddButton(true, '', false);
//     if (!this.currentVariant){
//       this.toggleAddButton(true, '', true);
//       this.setUnavailable();
//     }else {
//       this.updateMedia();
//       this.updateVariantInput();
//       this.updateURL();
//       this.renderProductInfo();
//       this.renderFindLoaction();
//     }
//   }
//   updateMasterId() {
//     this.currentVariant = this.getVariantData().find((variant) => {
//       return !variant.options.map((option, index) => {
//         return this.options[index] === option;
//       }).includes(false);
//     });
//   }
//   updateMedia() {
//     if (!this.currentVariant) return;
//     if (!this.currentVariant.featured_media) return;
//     var fetured_id = this.currentVariant.featured_media.id;
//     if(document.querySelector('.media-thumb')){
//       document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
//         var mediaid = e.dataset.id;
//         if(mediaid==fetured_id){
//           new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
//         }
//       });
//     }
//     if (document.querySelector('.media-grid-column').classList.toString().includes('swiper-slide')) {
//       var media_id = this.currentVariant?.featured_media?.id;
//       if (media_id) {
//         if (document.querySelector('.media-grid-column[data-media-id="'+ media_id +'"]')) {
//           var image_index = parseInt(document.querySelector('.media-grid-column[data-media-id="'+ media_id +'"]').getAttribute('data-swiper-slide-index'));
//           if (swiper && swiper.slideTo) {
//             swiper.slideTo(image_index, 1000, false);
//           }
//           // console.log('image_index', image_index);
//         }
//       }
//     }
//   }
//   updateURL() {
//     if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
//     window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
//   }
//   updateVariantInput() {
//     const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
//     productForms.forEach((productForm) => {
//       const input = productForm.querySelector('input[name="id"]');
//       input.value = this.currentVariant.id;
//       input.dispatchEvent(new Event('change', { bubbles: true }));
//     });
//   }
//   updateOptions() {
//     const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
//     const fieldlen = fieldsets.length;
//     let option_count = 0;
//     fieldsets.forEach(function(eachfield){
//       var checked_gender = eachfield.querySelector('input:checked');
//       if(checked_gender){
//         option_count++;
//       }
//     });
//     this.options = fieldsets.map((fieldset) => {
//       if(option_count>=fieldlen){
//         return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
//       }
//     });
//     if(option_count>=fieldlen){
//       document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
//       document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
//     }else{
//       document.querySelector('.choose-cart').classList.add('hide-selectore-button');
//       document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
//     }   
//   }
//   renderProductInfo() {
//     fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
//     .then((response) => response.text())
//     .then((responseText) => {
//       const id = `price-${this.dataset.section}`;
//       const html = new DOMParser().parseFromString(responseText, 'text/html')
//       const destination = document.getElementById(id);
//       const source = html.getElementById(id);
//       if (source && destination) destination.innerHTML = source.innerHTML;
//       if(this.currentVariant){
//         this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
//       }
//     });
//   }
//   renderFindLoaction() {
//     fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
//     .then((response) => response.text())
//     .then((responseText) => {
//       const id = `find-loaction-${this.dataset.section}`;
//       const html = new DOMParser().parseFromString(responseText, 'text/html')
//       const destination = document.getElementById(id);
//       const source = html.getElementById(id);
//       if (source && destination) destination.innerHTML = source.innerHTML;
//       if(this.currentVariant){
//         this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
//       }
//     });
//   }
  
//   toggleAddButton(disable = true, text, modifyClass = true) {
//     const productForm = document.getElementById(`product-form-${this.dataset.section}`);
//     if (!productForm) return;
//     const addButton = productForm.querySelector('[name="add"]');
//     const bisTrigger = productForm.querySelector(`.product-bis-trigger-${this.dataset.section}`);
//     const addButtonText = productForm.querySelector('[name="add"] > span');
//     const addButtonText2 = bisTrigger.querySelector('span');
//     if (!addButton) return;
//     setTimeout(function() {
//       if (disable) {
//       bisTrigger.classList.remove('d-none');
//       addButton.classList.add('d-none');
//       addButton.setAttribute('disabled', 'disabled');
//       if (text) addButtonText.textContent = text;
//       if (text) addButtonText2.textContent = 'Sold out – Register your interest';
//       if (document.querySelectorAll('.snippet-addto-cart.wc_comming_soon').length) {
//         if (text) addButtonText2.textContent = 'Coming soon – Register your interest';
//       }
//     } 
//     }, 1000);
//     if (!disable) {
//       bisTrigger.classList.add('d-none');
//       addButton.classList.remove('d-none');
//       addButton.removeAttribute('disabled');
//       addButtonText.textContent = window.variantStrings.addToCart;
//       addButtonText2.textContent = 'Add to bag';
//     }
//     if (!modifyClass) return;
//   }


// //   toggleAddButton(disable = true, text = null, modifyClass = true) {
// //   const productForm = document.getElementById(`product-form-${this.dataset.section}`);
// //   if (!productForm) return;

// //   const addButton = productForm.querySelector('[name="add"]');
// //   const bisTrigger = productForm.querySelector(`.product-bis-trigger-${this.dataset.section}`);
// //   const addButtonText = productForm.querySelector('[name="add"] > span');

// //   if (!addButton) return;

// //   if (disable) {
// //     if (text) {
// //       addButtonText.textContent = text;
// //     }
// //     if (text === window.variantStrings.addToCart) {
// //       bisTrigger?.classList.remove('d-none');
// //       addButton.classList.add('d-none');
// //     } else {
// //       addButton.classList.remove('d-none');
// //       bisTrigger?.classList.add('d-none');
// //     }
// //     addButton.setAttribute('disabled', 'disabled');

// //   } else {
// //     bisTrigger?.classList.add('d-none');
// //     addButton.classList.remove('d-none');
// //     addButton.removeAttribute('disabled');
// //     addButtonText.textContent = window.variantStrings.addToCart || text;
// //   }

// //   if (!modifyClass) return;
// // }


//   setUnavailable() {
//     const button = document.getElementById(`product-form-${this.dataset.section}`);
//     const addButton = button.querySelector('[name="add"]');
//     const addButtonText = button.querySelector('[name="add"] > span');
//     const price = document.getElementById(`price-${this.dataset.section}`);
//     if (!addButton) return;
//     addButtonText.textContent = window.variantStrings.unavailable;
//   }
//   getVariantData() {
//     this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
//     return this.variantData;
//   }
// }
// customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
// document.querySelector('.product-addcart').addEventListener('click',function(evt){

//   this.classList.add('loder');
//   setTimeout(() => {
//     this.classList.remove('loder');
//   }, 2600);

//   evt.preventDefault();
//   const config = fetchConfig('javascript');
//   config.headers['X-Requested-With'] = 'XMLHttpRequest';
//   delete config.headers['Content-Type'];
//   var cartform = document.querySelector('.product-addcart').closest('form');
//   const formData = new FormData(cartform);  
//   config.body = formData;
//   fetch(`${routes.cart_add_url}`, config)
//   .then((response) => response.json())
//   .then((response) => {
//     if (response.status) {
//       document.querySelector('.product-form-error').innerHTML = response.description;
//       setTimeout(function(e){
//         document.querySelector('.product-form-error').innerHTML  = '';
//       },2000);
//       return;
//     }else{
//       if(typeof load_cart == 'function'){
//         load_cart();
//         setTimeout(function(e){
//           document.querySelector('body').classList.add('open-drawer');
//         },2000);
//       }else{
//         window.location.href = "/cart";
//       }
//     }
//   })
//   .catch((e) => {
//     console.error(e);
//   })
//   .finally(() => {

//   });
// });
document.querySelectorAll('.product-addcart').forEach(function(button) {
  button.addEventListener('click', function(evt) {
    evt.preventDefault();

    this.classList.add('loder');
    setTimeout(() => {
      this.classList.remove('loder');
    }, 2600);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var cartform = this.closest('form'); // use THIS button's form
    const formData = new FormData(cartform);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          document.querySelector('.product-form-error').innerHTML = response.description;
          setTimeout(function() {
            document.querySelector('.product-form-error').innerHTML = '';
          }, 2000);
          return;
        } else {
          if (typeof load_cart == 'function') {
            load_cart();
            setTimeout(function() {
              document.querySelector('body').classList.add('open-drawer');
            }, 2000);
          } else {
            window.location.href = "/cart";
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  });
});

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto'
    });
    var swiper2 = new Swiper(".media-nav", {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  }
}
product_slider();
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  }
}

// start mobile product slider
var init = false;
var swiper;
function swiperCard() {
  const swiperEl = document.querySelector(".inner-media.swiper");
  const desktopSwiper = swiperEl?.dataset.desktopSwiper === "true";
  
  if (window.innerWidth <= 1024 || desktopSwiper) {
    if (!init) {
      init = true;
      swiper = new Swiper(".inner-media.swiper", {
        slidesPerView: "auto",
        loop:true,
         pagination: {
          el: ".inner-media.swiper .swiper-pagination",
        },
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);
// end mobile product slider

// start go back button click
if(document.querySelector('.go-back-btn')){
  document.querySelector(".go-back-btn").addEventListener("click", function() {
    window.history.back();
  });
}

// window.addEventListener("pageshow", function(event) {
//   if (event.persisted) {
//     window.location.reload();
//   }
// });


// end go back button click

// start open size chart // find store
document.querySelectorAll('.size-chart-btn').forEach(function(button) {
  button.addEventListener('click', function() {
    document.body.classList.add('open-size-chart');
    document.body.classList.remove('open-mpb-quick-add');
  });
});

// Jd code
document.querySelectorAll('a[title="size-guide"]').forEach(function(button) {
  button.addEventListener('click', function() {
    document.body.classList.add('open-size-chart');
  });
});

const findStoreBtn = document.querySelector('.find-store span');
if (findStoreBtn) {
  findStoreBtn.addEventListener('click', function() {
    document.body.classList.add('open-find-store');
  });
}
// end open size chart // find store

// start on var change add value in div
function updateVariantValue() {
  let selected = document.querySelector('.snippet-variant-selector .variant-row-list input:checked');
  if (!selected) return;

  let selectedValue = selected.value.trim().toLowerCase();

  document.querySelectorAll(".js-var .var").forEach(el => {
    el.textContent = selected.value;
  });

  document.querySelectorAll(".acc .acc-bottom tbody").forEach((tbody, tableIndex) => {
    let table = tbody.closest("table");

    let headerRow = table.querySelector("thead tr") || tbody.querySelector("tr");
    if (!headerRow) return;

    table.querySelectorAll("thead th, thead td").forEach(cell => {
      cell.style.background = "";
    });

    tbody.querySelectorAll("th, td").forEach(cell => {
      cell.style.background = "";
    });

    let ths = headerRow.querySelectorAll("th, td");
    let matchedIndex = null;

    ths.forEach((th, idx) => {
      let thValue = th.textContent.trim().toLowerCase();
      // console.log(`Table ${tableIndex} - Column ${idx}:`, thValue);

      if (thValue === selectedValue) {
        matchedIndex = idx;
      }
    });

    if (matchedIndex === null) return;

    tbody.setAttribute("data-index", matchedIndex);
    let nth = matchedIndex + 1;

    let th = headerRow.querySelector(`th:nth-child(${nth}), td:nth-child(${nth})`);
    if (th) th.style.background = "#f0f0f0";

    tbody.querySelectorAll("tr").forEach(tr => {
      let td = tr.querySelector(`td:nth-child(${nth})`);
      if (td) td.style.background = "#f0f0f0";
    });
  });
}

updateVariantValue();
document.querySelectorAll(".snippet-variant-selector .variant-row-list input").forEach(input => {
  input.addEventListener("change", updateVariantValue);
});
// End on var change add value in div

// function updateVariantValue() {
//   let selected = document.querySelector('.snippet-variant-selector .variant-row-list input:checked');
//   if (selected) {
//     let val = selected.value;
//     document.querySelectorAll('.js-var .var').forEach(function(el) {
//       el.textContent = val;
//     });
//   }
// }
// updateVariantValue();
// document.querySelectorAll('.snippet-variant-selector .variant-row-list input').forEach(function(input) {
//   input.addEventListener('change', updateVariantValue);
// });
// end on var change add value in div

// start propduct page zoom
if (window.innerWidth > 1024) {

document.querySelectorAll('.media-grid .media-grid-inner').forEach(function(item) {
  item.addEventListener('click', function() {
    document.body.classList.add('active-zoom');
    let clone = this.cloneNode(true);
    let target = document.querySelector('.product-main-zoom');
    if (target) {
      // target.innerHTML = '';
      target.appendChild(clone);
    }
  });
});
function closeZoom() {
  document.body.classList.remove('active-zoom');
  setTimeout(() => {
    let target = document.querySelector('.product-main-zoom');
    if (target) {
      target.innerHTML = '';
    }
  }, 500);
}
document.addEventListener('keydown', function(e) {
  if (e.key === "Escape") {
    closeZoom();
  }
});
document.addEventListener('click', function(e) {
  if (e.target.closest('.zoom-out-btn')) {
    closeZoom();
  }
});
// end propduct page zoom

// start popup input change
function syncVariantInputs(selectorA, selectorB) {
  document.querySelectorAll(selectorA).forEach(function(input) {
    input.addEventListener('change', function() {
      let val = this.value;
      document.querySelectorAll(selectorB).forEach(function(otherInput) {
        if (otherInput.value === val) {
          otherInput.checked = true;
        }
      });
    });
  });
}
syncVariantInputs('.product-wrap .variant-row-list input', '.main-size-popup .variant-row-list input');
syncVariantInputs('.product-wrap .variant-row-list input', '.main-find-popup .variant-row-list input');
syncVariantInputs('.main-size-popup .variant-row-list input', '.product-wrap .variant-row-list input');
syncVariantInputs('.main-size-popup .variant-row-list input', '.main-find-popup .variant-row-list input');
syncVariantInputs('.main-find-popup .variant-row-list input', '.product-wrap .variant-row-list input');
syncVariantInputs('.main-find-popup .variant-row-list input', '.main-size-popup .variant-row-list input');
}
// end popup input change


// start close popup
if (window.innerWidth > 1025) {
   document.addEventListener('mouseup', function (e) {
    const popups = document.querySelectorAll(
      ".open-size-chart .main-size-popup .inner-size-popup, .open-find-store .main-find-popup .inner-find-popup"
    );
    popups.forEach(function (popup) {
      if (popup && !popup.contains(e.target)) {
        document.body.classList.remove('open-size-chart', 'open-find-store');
      }
    });
  });
}else{
  document.querySelectorAll('.close-popup .close-popup-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.body.classList.remove('open-size-chart', 'open-find-store');
    });
  });
}
// end close popup


// start Product Measurements Convert inches to centimeters
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".acc").forEach(function (blockEl) {
    const table = blockEl.querySelector(".acc-bottom table");
    const cmBtn = blockEl.querySelector(".cm");
    const inchBtn = blockEl.querySelector(".ic");
    if (!table || !cmBtn || !inchBtn) return;
    const originalValues = [];
    table.querySelectorAll("tbody tr").forEach(function (row, rIndex) {
      originalValues[rIndex] = [];
      row.querySelectorAll("td").forEach(function (cell, cIndex) {
        if (cIndex > 0) {
          originalValues[rIndex][cIndex] = parseFloat(cell.textContent.trim());
        }
      });
    });

    cmBtn.addEventListener("click", function () {
      cmBtn.classList.add("active");
      inchBtn.classList.remove("active");

      table.querySelectorAll("tbody tr").forEach(function (row, rIndex) {
        row.querySelectorAll("td").forEach(function (cell, cIndex) {
          if (cIndex > 0) {
            cell.textContent = originalValues[rIndex][cIndex];
          }
        });
      });
    });
    inchBtn.addEventListener("click", function () {
      inchBtn.classList.add("active");
      cmBtn.classList.remove("active");
      table.querySelectorAll("tbody tr").forEach(function (row, rIndex) {
        row.querySelectorAll("td").forEach(function (cell, cIndex) {
          if (cIndex > 0) {
            let cmVal = originalValues[rIndex][cIndex];
            let inchVal = (cmVal / 2.54).toFixed(1);
            cell.textContent = inchVal;
          }
        });
      });
    });
  });
});
// end Product Measurements Convert inches to centimeters



//Start ACC Accordian 
  let currentUnit = 'cm';
  document.querySelectorAll('.top-right .pm-button').forEach(button => {
    button.addEventListener('click', function () {
      if (!this.classList.contains('active')) {
        document.querySelectorAll('.top-right .pm-button').forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        currentUnit = this.classList.contains('cm') ? 'cm' : 'in';
        updateMG();
      }
    });
  });

  function updateMG() {
    const selected = document.querySelector('.snippet-variant-selector .variant-row-list input:checked');
    if (!selected) return;
    const selectedSize = selected.value.toLowerCase();
    const table = document.querySelector(".acc-bottom table");
    if (!table) return;

    const rows = table.querySelectorAll("tbody tr");
    const headerCells = rows[0].querySelectorAll("th");
    let sizeIndex = -1;
    headerCells.forEach((cell, idx) => {
      if (cell.textContent.trim().toLowerCase() === selectedSize) {
        sizeIndex = idx;
      }
    });

    if (sizeIndex === -1) return;
    for (let i = 1; i < rows.length; i++) {
      const cells = rows[i].querySelectorAll("td");
      const label = cells[0]?.textContent.trim().toLowerCase();
      const value = cells[sizeIndex]?.textContent.trim();

      if (!label || !value) continue;
      const sgItem = Array.from(document.querySelectorAll('.sg_item')).find(el => {
        return el.dataset.name.toLowerCase() === label;
      });

      if (sgItem) {
        const sgValue = sgItem.querySelector('.sg_value');
        if (sgValue) {
          let displayValue = value;
          if (currentUnit === 'in') {
            const inches = parseFloat(value) / 2.54;
            displayValue = inches.toFixed(2);
          }

          const unitLabel = currentUnit === 'cm' ? 'cm' : 'in';
          sgValue.textContent = `${selected.value}: ${displayValue} ${unitLabel}`;
        }
      }
    }
  }

updateMG();

document.querySelectorAll(".snippet-variant-selector .variant-row-list input").forEach(input => {
  input.addEventListener("change", updateMG);
});

document.querySelectorAll('.sg_head').forEach(item => {
  item.addEventListener('click', () => {
    const parentAcc = item.closest('.sg_item');
    const isOpen = parentAcc.classList.contains('open');
    const allAcc = parentAcc.parentElement.querySelectorAll('.sg_item');
    allAcc.forEach(acc => acc.classList.remove('open'));
    document.querySelectorAll('.sg_img').forEach(img => img.classList.remove('open'));

    if (!isOpen) {
      parentAcc.classList.add('open');
      const dataName = parentAcc.getAttribute('data-name');
      document.querySelectorAll('.sg_img').forEach(img => {
        if (img.getAttribute('data-name') === dataName) {
          img.classList.add('open');
        }
      });
    }
  });
});
// End Measuring Guide


//Start JD MAP
function initMultipleMaps() {
  const maps = document.querySelectorAll('.iia-map');
  if (!maps.length) return;
  if (typeof google === 'undefined' || !google.maps) return;
  const geocoder = new google.maps.Geocoder();

  maps.forEach((el) => {
    const address = el.getAttribute('data-address');
    if (!address) return;
    geocoder.geocode({ address }, (results, status) => {
      if (status === "OK" && results[0]) {
        const location = results[0].geometry.location;
        const map = new google.maps.Map(el, {
          center: location,
          zoom: 15,
          disableDefaultUI: true,
          draggable: false,
          zoomControl: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          styles: [
            { elementType: "geometry", stylers: [{ color: "#ffffff" }] },
            { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#555555" }] },
            { featureType: "road", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#d6d6d6" }] },
            { featureType: "poi", stylers: [{ visibility: "off" }] },
            { featureType: "transit", stylers: [{ visibility: "off" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          ],
        });

        new google.maps.Marker({
          position: location,
          map,
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 13,
            fillColor: "#000000",
            fillOpacity: 1,
            strokeWeight: 0,
          },
        });
      } else {
        console.error("Geocode failed for:", address, status);
      }
    });
  });
}

initMultipleMaps();
// End JD Map

// size model (event delegation so it works even if modal loads late)
document.addEventListener('click', function(e) {
  const item = e.target.closest('.acc-title');
  if (!item) return;
  const parentAcc = item.closest('.size-acc .acc');
  if (!parentAcc) return;
  const isOpen = parentAcc.classList.contains('open');
  const allAcc = parentAcc.parentElement.querySelectorAll('.size-acc .acc');
  allAcc.forEach(acc => acc.classList.remove('open'));
  if (!isOpen) {
    parentAcc.classList.add('open');
  }
});

// V-Fit Room — Fancybox lightbox init
(function() {
  if (typeof Fancybox === 'undefined') return;

  Fancybox.bind('[data-fancybox="v-fit"]', {
    animated: true,
    showClass: 'fancybox-fadeIn',
    hideClass: 'fancybox-fadeOut',
    Images: {
      zoom: false,
    },
    Toolbar: {
      display: ['close'],
    },
    on: {
      reveal: function(fancybox, slide) {
        // Autoplay video when lightbox opens
        var video = slide.contentEl ? slide.contentEl.querySelector('video') : null;
        if (video) {
          video.muted = true;
          video.play().catch(function() {});
        }
      },
      close: function(fancybox) {
        // Pause all videos when lightbox closes
        fancybox.carousel.slides.forEach(function(slide) {
          var video = slide.contentEl ? slide.contentEl.querySelector('video') : null;
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        });
      }
    }
  });
})();

// FIX 2: V-Fit - Hide section if no media exists (matches demo-1 - section only shows with media)
document.addEventListener('DOMContentLoaded', function() {
  const vFitSections = document.querySelectorAll('.product-corner-thumbnail');
  vFitSections.forEach(section => {
    const hasMedia = section.querySelector('.v-fit-preview, .product-corner-thumbnail-video');
    
    // Hide if no media exists (section only shows with media, text is optional)
    if (!hasMedia) {
      section.style.display = 'none';
    } else {
      // Ensure it's visible if media exists
      section.style.display = '';
    }
  });
});

// FIX 3: Sticky info behavior - Ensure it sticks properly
document.addEventListener('DOMContentLoaded', function() {
  const stickyInfo = document.querySelector('.sticky-info');
  if (!stickyInfo) return;
  
  let lastScrollTop = 0;
  
  window.addEventListener('scroll', function() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > lastScrollTop) {
      // Scrolling down
      document.body.classList.remove('scroll-up');
      document.body.classList.add('scroll-down');
    } else {
      // Scrolling up
      document.body.classList.remove('scroll-down');
      document.body.classList.add('scroll-up');
    }
    
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }, false);
  
  // Ensure sticky works on initial load - force reflow
  if (window.innerWidth > 1024) {
    // Force reflow to ensure sticky positioning is calculated correctly
    void stickyInfo.offsetHeight;
    
    // Recalculate on resize to handle dynamic content
    window.addEventListener('resize', function() {
      if (window.innerWidth > 1024) {
        void stickyInfo.offsetHeight;
      }
    });
  }
});

// FIX 4: V-Fit video autoplay
document.addEventListener('DOMContentLoaded', function() {
  const vFitVideos = document.querySelectorAll('.v-fit-video');
  vFitVideos.forEach(function(video) {
    video.muted = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('muted', '');
    
    function attemptPlay() {
      if (video.readyState >= 2) {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.then(function() {
            // Success
          }).catch(function(error) {
            const tryPlayOnInteraction = function() {
              video.play().catch(function(err) {
                // Failed
              });
            };
            document.addEventListener('click', tryPlayOnInteraction, { once: true });
            document.addEventListener('touchstart', tryPlayOnInteraction, { once: true });
          });
        }
      } else {
        video.addEventListener('loadeddata', function() {
          attemptPlay();
        }, { once: true });
        video.addEventListener('canplay', function() {
          attemptPlay();
        }, { once: true });
        video.load();
      }
    }
    
    attemptPlay();
    
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            attemptPlay();
          }
        });
      }, { threshold: 0.1 });
      
      observer.observe(video);
    }
    
    setTimeout(function() {
      if (video.paused) {
        attemptPlay();
      }
    }, 500);
  });
});
